module.exports = __webpack_public_path__ + "img/bar-da-liga.61bf7cd6.jpg";